import axios from "@axios";

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map((camera) => ({
        value: camera.id,
        label: camera.name,
      }));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get("v1/camera_manager/admin/camera", { params });

      if (!data.success) {
        return [];
      }

      commit("setData", data.data);
      return data;
    },
    async export({ commit }, params) {
      const { data } = await axios.get("v1/camera_manager/admin/camera", {
        params: {
          ...params,
          export: true,
        },
        headers: {
          "Content-Disposition": "attachment; filename=template.xlsx",
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      });

      return data;
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/camera_manager/admin/camera/${id}`, params);

      return data;
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/camera_manager/admin/camera/${id}`);

      return data;
    },
    async update(_, params) {
      const { data } = await axios.post(
        `v1/camera_manager/admin/camera/api/update`,
        params
      );

      return data;
    },
    async updateStatus(_, id) {
      const { data } = await axios.put(`v1/camera_manager/admin/camera/api/status/${id}`);

      return data;
    },
    async getResellerCameras(_, params) {
      const { data } = await axios.post(
        `v1/camera_manager/admin/camera/api/get/reseller_cameras`,
        params
      );

      return data;
    },
    async updateResellerCameras(_, params) {
      const { data } = await axios.post(
        `v1/camera_manager/admin/camera/api/update/reseller_cameras`,
        params
      );

      return data;
    },
    clear({ commit }) {
      commit("setData", []);
    },
  },
};
